import { Menu, UnstyledButton } from '@mantine/core';
// icons
import {
    EllipsisVertical,
    PanelRight,
    PanelLeft,
    PanelBottom
} from 'lucide-react';
// utils
import { DRAWER_SIZE } from '@/components/Drawer/Drawers.utils.ts';
import type {
    TDrawerSize,
    TDrawerPosition
} from '@/components/Drawer/Drawer.types.ts';
import { cn } from '@/utils';
import useDrawerStore from '@/components/Drawer/Drawer.store.ts';
import DrawerMenuItem from '@/components/Drawer/components/DrawerMenuItem';

interface DrawerMenuProps {
    className?: string;
    name: string;
    size: TDrawerSize;
    position: TDrawerPosition;
}

const DrawerMenu = ({ className, name, size, position }: DrawerMenuProps) => {
    const setUI = useDrawerStore((state) => state.setUI);
    const handleSizeChange = (size_: TDrawerSize) => {
        setUI(name, { size: size_, position });
    };

    const handlePositionChange = (position_: TDrawerPosition) => {
        setUI(name, { size, position: position_ });
    };

    return (
        <Menu closeOnItemClick={false} shadow="md" width={200}>
            <Menu.Target>
                <UnstyledButton className={cn('leading-none', className)}>
                    <EllipsisVertical />
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Position</Menu.Label>
                <DrawerMenuItem
                    icon={<PanelLeft />}
                    isSelected={position === 'left'}
                    onClick={() => {
                        handlePositionChange('left');
                    }}
                >
                    Left
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={<PanelBottom />}
                    isSelected={position === 'bottom'}
                    onClick={() => {
                        handlePositionChange('bottom');
                    }}
                >
                    Bottom
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={<PanelRight />}
                    isSelected={position === 'right'}
                    onClick={() => {
                        handlePositionChange('right');
                    }}
                >
                    Right
                </DrawerMenuItem>

                <Menu.Divider />

                <Menu.Label>Size</Menu.Label>
                <DrawerMenuItem
                    icon={DRAWER_SIZE.sm}
                    isSelected={size === 'sm'}
                    onClick={() => {
                        handleSizeChange('sm');
                    }}
                >
                    Small
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={DRAWER_SIZE.md}
                    isSelected={size === 'md'}
                    onClick={() => {
                        handleSizeChange('md');
                    }}
                >
                    Medium
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={DRAWER_SIZE.lg}
                    isSelected={size === 'lg'}
                    onClick={() => {
                        handleSizeChange('lg');
                    }}
                >
                    Large
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={DRAWER_SIZE.xl}
                    isSelected={size === 'xl'}
                    onClick={() => {
                        handleSizeChange('xl');
                    }}
                >
                    Extra Large
                </DrawerMenuItem>

                <DrawerMenuItem
                    icon={DRAWER_SIZE.full}
                    isSelected={size === 'full'}
                    onClick={() => {
                        handleSizeChange('full');
                    }}
                >
                    Full
                </DrawerMenuItem>
            </Menu.Dropdown>
        </Menu>
    );
};

export default DrawerMenu;
